import { createContext, useContext, useState } from 'react';
import { createLocalMutationsStore } from './LocalMutationsStore';
import { jsx as _jsx } from "react/jsx-runtime";
const LocalMutationsContext = /*#__PURE__*/createContext(null);
export const LocalMutationsProvider = ({
  children
}) => {
  const [store] = useState(() => createLocalMutationsStore());
  return /*#__PURE__*/_jsx(LocalMutationsContext.Provider, {
    value: store,
    children: children
  });
};
export const useLocalMutationsStore = () => {
  const value = useContext(LocalMutationsContext);
  if (value === null) {
    throw new Error('useLocalMutationsStore called without LocalMutationsProvider');
  }
  return value;
};